import { render, staticRenderFns } from "./MovimentacaoProcesso.vue?vue&type=template&id=9ec8aad0"
import script from "./MovimentacaoProcesso.vue?vue&type=script&lang=js"
export * from "./MovimentacaoProcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports